import { Navigate, Outlet } from 'react-router'
import { SecurityRole } from '../constants'
import { useAuth } from '../contexts/AuthContext'

/**
 * Guards the site-wide admin area (/app/admin/*). Requires SUPER_ADMIN, not TEAM_ADMIN: those
 * pages list every team and user in the system and read every tenant's logs, which is not a team
 * admin's business. The API enforces the same thing — this only keeps the UI honest.
 */
export default function AdminRoute() {
  const { user } = useAuth()

  if (!user || user.securityRole < SecurityRole.SUPER_ADMIN) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
